import {AdSlot} from 'app/components/ads/AdSlot';
import React, {useEffect} from 'react';
import {SuperbannerStyle} from 'app/components/ads/adStylePlaceholders';
import {updateSkyscraperSkipping} from 'app/actions/skyscraperActions';
import {useDispatch} from 'react-redux';

const SuperbannerAdSlot = props => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      // Skyscraper is skipped if superbanner is a skin
      // Reset flag on unmount of superbanner
      dispatch(updateSkyscraperSkipping(true));
    };
  }, []);

  // Place ad only for desktop layout
  // Logic for displaying container inside AdSlot
  return <SuperbannerStyle as={AdSlot} adLayout='desktop' {...props} adUnit='Superbanner' />;
};

export default SuperbannerAdSlot;
